import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

// Defaults de capacidad por colaborador. Listado completo, se cachea por
// 5min porque cambia poco (la pestaña de Configuracion es la unica fuente
// de cambios y al editar invalida la query).
export function useCapacidadDefaults() {
  return useQuery({
    queryKey: ['capacidades', 'defaults'],
    queryFn: () => api.capacidades.listDefaults(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpsertCapacidadDefault() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ idCol, horasDefault, horasRevision }: { idCol: number; horasDefault: number; horasRevision: number }) =>
      api.capacidades.upsertDefault(idCol, horasDefault, horasRevision),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['capacidades'] });
    },
  });
}

// Capacidad efectiva por colaborador para un sprint dado. Trae default +
// override + horas asignadas en una sola request (calculado server-side).
// staleTime corto porque las horas asignadas cambian con cada edicion de
// tarea — preferimos refetch rapido a vista desfasada.
export function useEffectiveCapacidad(idSprint: number | null, opts?: { refetchInterval?: number }) {
  return useQuery({
    queryKey: ['capacidades', 'effective', idSprint],
    queryFn: () => api.capacidades.effective(idSprint!),
    enabled: idSprint !== null,
    staleTime: 30 * 1000,
    // refetchInterval opcional: planning lo usa para mantener las barras vivas.
    refetchInterval: opts?.refetchInterval,
  });
}

export function useUpsertCapacidadOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ idSprint, idCol, horasOverride }: { idSprint: number; idCol: number; horasOverride: number }) =>
      api.capacidades.upsertOverride(idSprint, idCol, horasOverride),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['capacidades'] });
    },
  });
}

export function useDeleteCapacidadOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ idSprint, idCol }: { idSprint: number; idCol: number }) =>
      api.capacidades.deleteOverride(idSprint, idCol),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['capacidades'] });
    },
  });
}
